module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-contact-31f74a9f542addd107d0a96df5d10f60.webp";